import { Layout } from 'antd';
import React, { useEffect, useState } from 'react';
import { Button, Modal, message, Spin, Image, Upload } from "antd";
import { DeleteOutlined, UploadOutlined, ReloadOutlined, LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import SideNavBar from '../../Components/SideBar/Sidebar';
import { Content, Header } from 'antd/es/layout/layout';
import Navbar from '../../Components/Support/Header';
import { embedDashboard } from "@superset-ui/embedded-sdk";
import { BaseUrl, JsonConfig, FormConfig, UserName } from '../../Repository/BaseRepository';
import axios from "axios";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";
// import './Graph.css'
import "../../GlobalCss/SPF/Graph.css";
import { routes } from '../../Utils/Utils';

// import * as pbi from 'powerbi-client';


const Graph = () => {

    const tenantName = Cookies.get("tenant_name");
    const [hrSourceFile, setHrSourceFile] = useState([]);
    const [spin, setSpin] = useState(false)
    const [hrUploader, setHrUploader] = useState("");
    const handleUpload = async (options) => {
        try {
            setSpin(true)
            const { file, onSuccess, onError } = options;
            const updatedDeductionFile = { file, status: "uploading" }
            const formData = new FormData();
            formData.append("file", file);
            setHrSourceFile([])
            setHrUploader(file.name);
            const response = await axios.post(`${BaseUrl}AnalyticsData/CFOUpload`, formData, FormConfig)
            if (response.data.isSuccess === true) {
                onSuccess(file)
                message.success(`File uploaded successfully`);
                updatedDeductionFile.status = "done"
                setHrSourceFile([updatedDeductionFile])
                setHrUploader('')
                setSpin(false)
            }
            else {
                onError(file)
                message.error(response.data.message);
                updatedDeductionFile.status = "error"
                setHrSourceFile([updatedDeductionFile])
                setHrUploader('')
                setSpin(false)
            }
        }
        catch (error) {
            message.error(`File upload failed`);
            setHrUploader('')
            setSpin(false)
        }
    }
    const itemRender = (originNode, file) => {
        let statusColor;
        if (file.status === "done") {
            statusColor = "green";
        } else if (file.status === "error") {
            statusColor = "#f55451";
        }
        let fileExists = false;
        if (hrSourceFile.length > 0) {
            fileExists = true;
        }
        return <>
            <div style={{ display: "flex", height: 'auto', height: 'auto', width: 400, wordWrap: "break-word", marginTop: "15px", }}>
                <div style={{ color: statusColor, height: 'auto', display: "flex", wordWrap: "break-word", borderRadius: "4px" }}>{fileExists ?
                    <div style={{ height: 'auto', width: 'fit-content', wordBreak: 'break-all', }}>{hrSourceFile[0].file.name} </div> : null}</div>
                <DeleteOutlined style={{ marginLeft: 5 }} onClick={() => setHrSourceFile([])} />
            </div>
        </>;
    };

    return (
        <>
            <Layout style={{ backgroundColor: "white", height: "100vh", display: "flex", overflow: "hidden" }} >
                <SideNavBar />
                <Layout className="whole-div">
                    <Header className="timecards-header">
                        <Navbar />
                    </Header>
                    <Content style={{ overflow: 'auto', height: "100%", marginLeft: 20 }}>
                        <div className="expensepages">
                            <Link to={`/${tenantName}/utilities`}><Button className="page-button">Utilities</Button></Link>
                            <Link to={`/${tenantName}/activitylog`}><Button className="page-button">Activity Log</Button></Link>
                            <Link to={`/${tenantName}/analytics`}><Button className="currentpreview-button">Analytics (File Upload)</Button></Link>
                            <Link to={`/${tenantName}/Analytics 2`}><Button className="page-button">Analytics</Button></Link>

                        </div>
                        <div className="upload-list">
                            <div className='head1'>Upload CFO File</div>
                            <div className="inputfile-upload" style={{marginLeft:20, marginTop:15}}>
                                <Upload
                                    className="hr-upload-file"
                                    name="file"
                                    customRequest={handleUpload}
                                    itemRender={itemRender}
                                    fileList={hrSourceFile}
                                    accept=".xls,.xlsx"
                                    onRemove={() => setHrSourceFile([])}
                                    // style={{ border: "1px solid #3B52DF", borderRadius: 10, borderStyle: "dashed" }}
                                >
                                    <div className='hr-content-file'>
                                        <span className="hrfile-name">Upload File</span>
                                        {spin ? <Spin indicator={<LoadingOutlined className="upload-spinner" style={{ fontSize: 16, marginLeft: 7, color: "#3B52DF" }} spin />} />

                                            // <Spin size="medium" style={{ marginLeft: '5px', marginTop:"3px" }} /> 
                                            : <Image src="./Images/uploadimg (2).png"
                                                style={{
                                                    border: "none",
                                                    width: 19,
                                                    height: 17,
                                                }}
                                                showPreviewIcon={false}
                                                preview={false} />}
                                    </div>
                                </Upload>
                                {hrUploader.length > 0 ? <div style={{ width: 'fit-content', wordBreak: 'break-all', marginBottom: 2, color: "#3B52DF" }}>{hrUploader}</div> : null}
                            </div>
                        </div>
                        {/* <div id="my-superset-container" className='superset-container'></div> */}
                        <div className="powerbi-iframe-container">
                        <iframe title="CFO Upload functionality" width="1140" height="541.25" src="https://app.powerbi.com/view?r=eyJrIjoiM2QwZTVjMTUtNDQ4Yi00YzdiLTg3MzktMGE1ZGI0ZTk4YTZmIiwidCI6IjRhOTcxMjNiLTI0M2MtNGU5NS1iY2U5LTQxMTNkYmQzMTEyMSIsImMiOjF9" frameborder="0" allowFullScreen="true"></iframe>
                            {/* <iframe title="CFO Upload functionality" width="1140" height="541.25" src="https://app.powerbi.com/view?r=eyJrIjoiM2QwZTVjMTUtNDQ4Yi00YzdiLTg3MzktMGE1ZGI0ZTk4YTZmIiwidCI6IjRhOTcxMjNiLTI0M2MtNGU5NS1iY2U5LTQxMTNkYmQzMTEyMSIsImMiOjF9" frameborder="0" allowFullScreen="true"></iframe> */}
                            {/* { <iframe title="spf payroll_Prod" width="1140" height="541.25" src="
https://app.powerbi.com/view?r=eyJrIjoiMWU5Y2U4OTAtZWIyZC00MWFiLWFlMzMtNDRlMTQzN2E0NzcyIiwidCI6IjRhOTcxMjNiLTI0M2MtNGU5NS1iY2U5LTQxMTNkYmQzMTEyMSIsImMiOjF9"
frameborder="0" allowFullScreen="true"></iframe> } */}
                        </div>
                    </Content>
                </Layout>
            </Layout>
        </>
    );
};

export default Graph;
